{
  "close": "Cerrar",
  "sidebar": {
    "toggle": "Alternar barra lateral",
    "title": "Barra lateral",
    "description": "Muestra la barra lateral móvil."
  },
  "or": "o",
  "changeLanguage": "Idioma",
  "locales": {
    "en": "English",
    "es_MX": "Español (México)"
  },
  "form": {
    "saveFailed": "Algo salió mal. Inténtalo de nuevo."
  },
  "error": {
    "title": "Vaya, se nos cayó uno",
    "body": "Esto no debería haber pasado. Y sin embargo, aquí estamos.",
    "report": "Cuéntanos qué viste",
    "home": "Ir al inicio"
  },
  "contact": {
    "name": "Tu nombre",
    "email": "Tu correo electrónico",
    "company": "Tu empresa",
    "message": "¿En qué podemos ayudarte?",
    "send": "Enviar mensaje",
    "sent": "¡Mensaje enviado! Te responderemos pronto."
  }
}
